import { z } from 'zod';
import * as FlatModels from '../../internal';

export enum MediaOrder {
  NONE = '',
  ASC = 'ASC',
  DESC = 'DESC'
}

export const MediaSearchSchema = z.object({
  searchString: z.string().min(0),
  typeFilter: z.array(FlatModels.MediaEntityModels.MediaType).optional(),
  uploadedByMe: z.boolean().optional(),
  usedInFilter: z.array(FlatModels.NodeEntityModels.NodeEntityTypeSchema).optional(),
  // selectedMedia: z.array(FlatModels.MediaEntityModels.MediaEntityTypeSchema).optional(),
  page: z.number().optional(),
  order: z.nativeEnum(MediaOrder).optional(),
  orderBy: z.string().optional(),
});

export type MediaSearch = z.infer<typeof MediaSearchSchema>;

export const SearchResultSchema = z.object({
  id: z.string().uuid(),
});

export type SearchResult = z.infer<typeof SearchResultSchema>;

export const MediaUsedInResultEntrySchema = z.object({
  id: z.string().uuid(),
  title: z.string()
});

export type MediaUsedInResultEntry = z.infer<typeof MediaUsedInResultEntrySchema>;

export const MediaUsedInResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: z.object({
    id: z.string().uuid(),
    results: z.array(MediaUsedInResultEntrySchema)
  })
});

export type MediaUsedInResult = z.infer<typeof MediaUsedInResultSchema>;
